import { SubscriptionType } from "common/app-plans";
import SwitchToggle from "designer/builder/ui/views/switch-toggle/switch-toggle";
import { GlideFC } from "lib/glide-fc";
import { useCallback } from "react";
import { styled } from "sharedUI/styles";

const SubscriptionToggleContainer = styled.div`
    display: flex;
    align-items: center;

    > .info {
        font-size: 11px;
        margin-right: 6px;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        > .yearly {
            font-weight: 400;
            line-height: 13px;
        }
        > .save {
            font-size: 9px;
            font-weight: 700;
            line-height: 10px;
            text-transform: uppercase;
            color: ${p => p.theme.b400};
        }
    }
`;

interface Props {
    susbscription: SubscriptionType;
    subscriptionChange: (billing: SubscriptionType) => void;
}

const SubscriptionToggle: GlideFC<Props> = p => {
    const { susbscription, subscriptionChange } = p;

    const billingChanged = useCallback(
        (toggled: boolean) => {
            subscriptionChange(toggled ? SubscriptionType.Annual : SubscriptionType.Monthly);
        },
        [subscriptionChange]
    );

    return (
        <SubscriptionToggleContainer>
            <div className="info">
                <div className="yearly">Pay Yearly</div>
                <div className="save">SAVE 25%</div>
            </div>
            <SwitchToggle
                toggled={susbscription === SubscriptionType.Annual}
                onChange={billingChanged}
                size="default"
            />
        </SubscriptionToggleContainer>
    );
};

export default SubscriptionToggle;
